<template>
    <div class="setting-container">
        <head-bar title="设置" :fixed="true"></head-bar>
        <div class="user-menu-container margin-t">
            <ul class="user-menu-list">
                <li
                    class="meun-item"
                    @click="gotoView('/account/change/password')"
                >
                    <div class="meun-left">
                        <span>修改密码</span>
                    </div>
                    <div class="meun-right"></div>
                </li>
                <li class="meun-item" v-if="userInfo.isWeChatBind">
                    <div class="meun-left">
                        <span>微信({{ userInfo.weChatName }})</span>
                    </div>
                    <div class="meun-right" @click="removeWechat">
                        <span>解除绑定</span>
                    </div>
                </li>
                <li
                    class="meun-item"
                    v-if="!userInfo.isWeChatBind && $isBuildWechat"
                >
                    <div class="meun-left">
                        <span>微信(未绑定)</span>
                    </div>
                    <div class="meun-right" @click="wechatLogin">
                        <span>去绑定</span>
                    </div>
                </li>
            </ul>
        </div>
        <div class="logout-btn" @click="logout">
            <span>退出登陆</span>
        </div>
    </div>
</template>
<script>
import { removeUserToken, removeUserId, createBasket } from "@/utils/auth";
import wechatAuthorization from "@/utils/wechat";
import HeadBar from "@/components/HeadBar.vue";
import { Dialog } from "vant";
export default {
    name: "Setting",
    components: {
        HeadBar,
    },
    beforeMount() {
        this.getUserInfo();
    },
    data() {
        return {
            userInfo: {},
        };
    },
    methods: {
        /**
         * @description 跳转页面
         */
        gotoView(path) {
            if (!path) return;
            this.$router.push({
                path: path,
            });
        },
        /**
         * @description 获取用户信息
         */
        getUserInfo() {
            let _this = this;
            let defaultInfo = {
                userNumber: "001",
            };
            this.$axios.post(this.$api.userApi.getUserInfo).then((response) => {
                let userInfo = response.data || defaultInfo;
                _this.userInfo = userInfo;
            });
        },
        /**
         * @description 微信登录
         */
        wechatLogin() {
            //来源用户自己
            const bind_source_self = 100;
            wechatAuthorization(bind_source_self);
        },
        /**
         * @description 解除微信绑定
         */
        removeWechat() {
            let _this = this;
            Dialog.confirm({
                title: "提示",
                message: "是否确定解除微信绑定?",
                confirmButtonColor: "#4BC227",
            })
                .then(() => {
                    _this.$axios
                        .post(_this.$api.accountApi.removeWechat, {})
                        .then((response) => {
                            _this.getUserInfo();
                        })
                        .catch(() => {});
                })
                .catch(() => {});
        },
        /**
         * @description 登出
         */
        logout() {
            removeUserToken();
            removeUserId();
            createBasket();
            this.$router.push("/");
        },
    },
};
</script>
<style lang="less" scoped>
.setting-container {
    padding-top: 110px;
}
.user-menu-container {
    margin: 130px auto 0;
    width: 750px;
    background-color: #fff;
    &.margin-t {
        margin: 20px auto 0;
    }
    .user-menu-list {
        margin: 0 auto;
        width: 690px;
        > .meun-item {
            overflow: hidden;
            height: 110px;
            width: 690px;
            border-bottom: 1px solid #f2f2f2;
            .meun-left {
                float: left;
                width: 345px;
                height: 115px;
                background-size: 48px;
                background-repeat: no-repeat;
                background-position: left center;
                font-size: 28px;
                line-height: 115px;
                color: #333;
            }
            .meun-right {
                float: right;
                padding-right: 40px;
                width: 305px;
                height: 110px;
                background-image: url("../../../public/images/common/arrow-right-icon.png");
                background-position: center right;
                background-repeat: no-repeat;
                background-size: 40px;
                font-size: 24px;
                line-height: 110px;
                text-align: right;
                color: #666;
            }
        }
    }
}
.logout-btn {
    margin: 60px auto;
    width: 690px;
    height: 70px;
    background-color: #4bc227;
    -ms-border-radius: 36px;
    -webkit-border-radius: 36px;
    border-radius: 36px;
    font-size: 28px;
    line-height: 70px;
    text-align: center;
    color: #fff;
}
</style>
